import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Home } from "@/screens/Home";
import { SignIn } from "./screens/SignIn";
import { useAuth, useAuthLoader } from "./store/auth";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  GlobalStyles,
} from "@mui/material";
import { AuthLayout } from "./layouts/AuthLayout";
import { ProductionReport } from "./screens/ProductionReport";
import { ReportFormLayout } from "./layouts/ReportFormLayout";
import { SuppliesReport } from "./screens/SuppliesReport";
import { FuelReport } from "./screens/FuelReport";
import { ReportComment } from "./screens/ReportComment";
import "./config/logrocket";
import "./config/sentry";
import { ReportSummary } from "./screens/ReportSummary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TransportationControlReport } from "./screens/TransportationControlReport";
import { BatchReportControl } from "./screens/BatchControlReport";
import { ReportsHistory } from "./screens/ReportsHistory";
import { HistoryLayout } from "./layouts/HistoryLayout";
import { ReportsHistoryDetail } from "./screens/ReportsHistoryDetail";

export default function App() {
  useAuthLoader();
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/ingresar" element={<SignIn />} />
          <Route path="/" element={<AuthLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/historial" element={<HistoryLayout />}>
              <Route path="" element={<ReportsHistory />} />
              <Route path=":id" element={<ReportsHistoryDetail />} />
            </Route>
            <Route path="/formulario-reporte" element={<ReportFormLayout />}>
              <Route path=":id/produccion" element={<ProductionReport />} />
              <Route path=":id/partidas" element={<BatchReportControl />} />
              <Route path=":id/suministros" element={<SuppliesReport />} />
              <Route path=":id/equipos" element={<FuelReport />} />
              <Route
                path=":id/transporte"
                element={<TransportationControlReport />}
              />
              <Route path=":id/comentarios" element={<ReportComment />} />
              <Route path=":id/resumen" element={<ReportSummary />} />
              <Route path="*" element={<Navigate to={"/"} />} />
            </Route>
          </Route>
        </Routes>
        <InvalidUserDialog />
        <ToastContainer position="bottom-center" />
      </BrowserRouter>
      <GlobalStyles
        styles={`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }`}
      />
    </>
  );
}

const InvalidUserDialog = () => {
  const invalidUser = useAuth((store) => store.invalidUser);
  const setInvalidUser = useAuth((store) => store.setInvalidUser);
  const clearInvalidUser = useAuth((store) => store.clearInvalidUser);
  return (
    <Dialog open={invalidUser} onClose={setInvalidUser}>
      <DialogTitle>{"Error"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          No tienes permisos para acceder a esta aplicación
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={clearInvalidUser} autoFocus>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};
